const AddYourSchoolIndexPageInfo = [
  {
    title: 'Add your school to our platform',
    description:
      ' By adding your school to our platform you will automatically get access to a extensive pool of quality applicants. Reduce workload on your staff and save money by managing all applications online. ',
  },
]

export default AddYourSchoolIndexPageInfo
